export default {
  default: () => import("/home/runner/work/wow-guide/wow-guide/frontend-wg3/layouts/default.vue").then(m => m.default || m)
}